// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Types
import NavigationBarProps from "types/globals/navigationBar/navigationBarProps";
// MARK: Components
import DesktopNavigationBar from "./components/desktop";
import MobileNavigationBar from "./components/mobile";


// MARK: Styled Components
const Container = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: auto;
  z-index: 100;
`;


// MARK: React Component

// Styleguide & Datapoints

// Component
function NavigationBar({ data }: NavigationBarProps) {
  // Mark: Variables
  const activeRoute = typeof window === "undefined" ? "" : window.location.pathname;

  // Mark: Render
  return <Container>
      <MobileNavigationBar data={data} activeRoute={activeRoute} />
      <DesktopNavigationBar data={data} activeRoute={activeRoute} />
  </Container>
}

export default NavigationBar;
